module.exports = __webpack_public_path__ + "static/teaser-c0cfba9161479c50e1f4e4530d1a8e12.gif";